export namespace TaskGroupsHubItemKeys {
    export const ImportMenuItem = "task-group-import";
    export const SecurityMenuItem = "task-group-project-security";
    export const SearchFilterKey = "task-groups-search-key";
    export const PivotItemKey = "task-groups-list-pivot-item";
}

export namespace ActionKeys {
    export const TaskGroupsActionHub = "ACTION_HUB_KEY_TASK_GROUPS_ACTION_HUB";
}

export namespace ActionCreatorKeys {
    export const TaskGroupsActionCreator = "ACTION_CREATOR_KEY_TASK_GROUPS_ACTION_CREATOR";
}

export namespace StoreKeys {
    export const TaskGroupsStore = "STORE_KEY_TASK_GROUPS_STORE";
}

export namespace TaskGroupsHubInstanceIds {
    export const ActionCreatorInstanceIdPrefix = "TASK_GROUPS_HUB_ACTION_CREATOR";
    export const StoreInstanceIdPrefix = "TASK_GROUPS_HUB_STORE";
}

export namespace TaskGroupsListColumnKeys {
    export const Name = "task-groups-name-column-key";
    export const ModifiedBy = "task-groups-modifiedby-column-key";
    export const Description = "task-groups-description-column-key";
    export const ModifiedDate = "task-groups-modifieddate-column-key";
}

export namespace TaskGroupsListMenuItemKeys {
    export const Delete = "task-group-list-delete";
    export const Export = "task-group-list-export";
    export const Security = "task-group-list-security";
}

export namespace TaskGroupsListMessageBarKeys {
    export const ErrorBarParentKey = "task-groups-list-error-bar-key";
}

export namespace HelpLinks {
    export const TaskGroupsLearnMore = "https://go.microsoft.com/fwlink/?LinkId=761053";
}